import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-contenido" }
const _hoisted_3 = { class: "formulario-opcion tipo-indicador-flex" }
const _hoisted_4 = ["for"]
const _hoisted_5 = {
  key: 0,
  class: "fila-select-boton"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "campo-fijo" }
const _hoisted_9 = {
  key: 0,
  class: "formulario-opcion nuevo"
}
const _hoisted_10 = { class: "nuevo-header" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "formulario-opcion tipo-indicador-flex" }
const _hoisted_13 = { class: "fila-select-boton" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 1,
  class: "formulario-opcion nuevo"
}
const _hoisted_17 = { class: "nuevo-header" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "formulario-opcion tipo-indicador-flex" }
const _hoisted_20 = { class: "fila-select-boton" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 2,
  class: "formulario-opcion nuevo"
}
const _hoisted_24 = { class: "nuevo-header" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "formulario-opcion tipo-indicador-flex" }
const _hoisted_27 = { class: "fila-select-boton" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 3,
  class: "formulario-opcion nuevo"
}
const _hoisted_31 = { class: "nuevo-header" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "formulario-opcion" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "botones" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled"]

import { ref, computed, watch } from 'vue'
import type TipoComponente from '@/interfaces/TipoComponente'

interface UnidadItem { id_unidad: number; nombre: string }
interface FormulaItem { id_formula: number; nombre: string; clasificacion?: string }
interface NombreItem { id_nombre: number; nombre: string }


export default /*@__PURE__*/_defineComponent({
  __name: 'FormularioIndicador',
  props: {
    visible: { type: Boolean },
    modo: {},
    loading: { type: Boolean },
    tiposDisponibles: {},
    unidadesDisponibles: {},
    formulasDisponibles: {},
    nombresDisponibles: {},
    tipoInicial: {},
    nombreInicial: {},
    unidadInicial: {},
    formulaInicial: {},
    descripcionInicial: {}
  },
  emits: ["aceptar", "cancelar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Formulario de alta y edición de un indicador.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const tipoIndicadorId = ref<number | ''>('')
const mostrarNuevoTipo = ref(false)
const nuevoTipoNombre = ref('')

const nombreIndicadorId = ref('')
const mostrarNuevoNombre = ref(false)
const nuevoNombreIndicador = ref('')
const descripcionIndicador = ref('')

const unidadIndicadorId = ref('')
const mostrarNuevaUnidad = ref(false)
const nuevaUnidadNombre = ref('')

const formulaIndicadorId = ref('')
const mostrarNuevaFormula = ref(false)
const nuevaFormulaNombre = ref('')

// Cuando se abre el modal, inicializar los campos
watch(() => props.visible, (val) => {
  if (val) {
    tipoIndicadorId.value = props.tipoInicial ?? ''
    nombreIndicadorId.value = props.nombreInicial ?? ''
    unidadIndicadorId.value = props.unidadInicial ?? ''
    formulaIndicadorId.value = props.formulaInicial ?? ''
    descripcionIndicador.value = props.descripcionInicial ?? ''
    mostrarNuevoTipo.value = false
    nuevoTipoNombre.value = ''
    mostrarNuevoNombre.value = false
    nuevoNombreIndicador.value = ''
    mostrarNuevaUnidad.value = false
    nuevaUnidadNombre.value = ''
    mostrarNuevaFormula.value = false
    nuevaFormulaNombre.value = ''
  }
})

watch(tipoIndicadorId, (nuevoId) => {
  if (nuevoId) {
    mostrarNuevoTipo.value = false
    nuevoTipoNombre.value = ''
  }
})

const nombreTipoActual = computed(() => {
  if (!props.tipoInicial) return '—'
  const tipo = props.tiposDisponibles.find(t => t.id_tipo_componente === props.tipoInicial)
  return tipo?.nombre ?? '—'
})

// Filtrar opciones duplicadas por nombre
const tiposUnicos = computed(() => {
  const vistos = new Set<string>()
  return props.tiposDisponibles.filter(t => {
    const nombre = (t.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

const unidadesUnicas = computed(() => {
  const vistos = new Set<string>()
  return props.unidadesDisponibles.filter(u => {
    const nombre = (u.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

// Clasificación derivada del tipo actualmente seleccionado o del nuevo tipo en edición
const clasificacionActual = computed(() => {
  if (mostrarNuevoTipo.value && nuevoTipoNombre.value.trim()) {
    const n = nuevoTipoNombre.value.toLowerCase()
    if (/document/.test(n)) return 'documental'
    if (/cuantitativ/.test(n)) return 'cuantitativa'
    if (/opini/.test(n)) return 'opinion'
    return ''
  }
  if (!tipoIndicadorId.value) return ''
  const tipo = props.tiposDisponibles.find(t => t.id_tipo_componente === tipoIndicadorId.value)
  const n = (tipo?.nombre ?? '').toLowerCase()
  if (/document/.test(n)) return 'documental'
  if (/cuantitativ/.test(n)) return 'cuantitativa'
  if (/opini/.test(n)) return 'opinion'
  return ''
})

const formulasUnicas = computed(() => {
  const base = clasificacionActual.value
    ? props.formulasDisponibles.filter(f => f.clasificacion === clasificacionActual.value)
    : props.formulasDisponibles
  const vistos = new Set<string>()
  return base.filter(f => {
    const nombre = (f.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

// Limpiar fórmula seleccionada cuando cambia la clasificación y ya no está en la lista
watch(clasificacionActual, () => {
  if (!formulaIndicadorId.value || !clasificacionActual.value) return
  const sigueDisponible = formulasUnicas.value.some(f => f.nombre === formulaIndicadorId.value)
  if (!sigueDisponible) formulaIndicadorId.value = ''
})

const nombresUnicos = computed(() => {
  const vistos = new Set<string>()
  return props.nombresDisponibles.filter(n => {
    const nombre = (n.nombre ?? '').trim().toLowerCase()
    if (vistos.has(nombre)) return false
    vistos.add(nombre)
    return true
  })
})

watch(nombreIndicadorId, (val) => {
  if (val) {
    mostrarNuevoNombre.value = false
    nuevoNombreIndicador.value = ''
  }
})

const puedeAceptar = computed(() => {
  const tipoValido = mostrarNuevoTipo.value
    ? !!nuevoTipoNombre.value.trim()
    : !!tipoIndicadorId.value

  const unidadValida =
    (mostrarNuevaUnidad.value && !!nuevaUnidadNombre.value.trim()) ||
    (!!unidadIndicadorId.value && !mostrarNuevaUnidad.value)

  const formulaValida =
    (mostrarNuevaFormula.value && !!nuevaFormulaNombre.value.trim()) ||
    (!!formulaIndicadorId.value && !mostrarNuevaFormula.value)

  const nombreValido = mostrarNuevoNombre.value
    ? !!nuevoNombreIndicador.value.trim()
    : !!nombreIndicadorId.value

  return tipoValido && unidadValida && formulaValida && nombreValido
})

function cancelar() {
  emit('cancelar')
}

function emitirAceptar() {
  if (!puedeAceptar.value) return
  emit('aceptar', {
    tipoIndicadorId: tipoIndicadorId.value,
    nuevoTipoNombre: nuevoTipoNombre.value,
    nombreIndicador: mostrarNuevoNombre.value ? nuevoNombreIndicador.value.trim() : nombreIndicadorId.value,
    unidadIndicadorId: unidadIndicadorId.value,
    nuevaUnidadNombre: nuevaUnidadNombre.value,
    formulaIndicadorId: formulaIndicadorId.value,
    nuevaFormulaNombre: nuevaFormulaNombre.value,
    descripcionIndicador: descripcionIndicador.value?.trim() || ''
  })
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.modo === 'modificar' ? 'Modificar indicador' : 'Agregar indicador'), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", {
              for: _ctx.modo === 'agregar' ? 'tipoIndicador' : undefined
            }, _cache[17] || (_cache[17] = [
              _createTextVNode(" Clasificación de Indicador "),
              _createElementVNode("small", null, "(Documental, cuantitativo o de opinión)", -1)
            ]), 8, _hoisted_4),
            (_ctx.modo === 'agregar')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("select", {
                    id: "tipoIndicador",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tipoIndicadorId).value = $event)),
                    disabled: _ctx.loading
                  }, [
                    _cache[18] || (_cache[18] = _createElementVNode("option", {
                      disabled: "",
                      value: ""
                    }, "Seleccione una clasificación", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposUnicos.value, (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t.id_tipo_componente,
                        value: t.id_tipo_componente
                      }, _toDisplayString(t.nombre), 9, _hoisted_7))
                    }), 128))
                  ], 8, _hoisted_6), [
                    [_vModelSelect, tipoIndicadorId.value]
                  ]),
                  _createElementVNode("button", {
                    class: "btn guardar",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (mostrarNuevoTipo.value = !mostrarNuevoTipo.value), ["prevent"]))
                  }, " Nuevo Tipo ")
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(nombreTipoActual.value), 1),
                  _cache[19] || (_cache[19] = _createElementVNode("p", { class: "nota-no-editable" }, "Este campo no puede modificarse.", -1))
                ], 64))
          ]),
          (_ctx.modo === 'agregar' && mostrarNuevoTipo.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { for: "nuevoTipoNombre" }, [
                    _createTextVNode(" Nombre del nuevo tipo "),
                    _createElementVNode("small", null, "(Seleccione la clasificación del indicador)")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nuevo-cerrar",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => {mostrarNuevoTipo.value = false; nuevoTipoNombre.value = ''})
                  }, "×")
                ]),
                _withDirectives(_createElementVNode("select", {
                  id: "nuevoTipoNombre",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((nuevoTipoNombre).value = $event)),
                  disabled: _ctx.loading
                }, _cache[21] || (_cache[21] = [
                  _createElementVNode("option", {
                    disabled: "",
                    value: ""
                  }, "Seleccione...", -1),
                  _createElementVNode("option", { value: "Información Documental" }, "Información Documental", -1),
                  _createElementVNode("option", { value: "Información Cuantitativa" }, "Información Cuantitativa", -1),
                  _createElementVNode("option", { value: "Información de Opinión" }, "Información de Opinión", -1)
                ]), 8, _hoisted_11), [
                  [_vModelSelect, nuevoTipoNombre.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _cache[23] || (_cache[23] = _createElementVNode("label", { for: "unidadIndicador" }, [
              _createTextVNode(" Unidad "),
              _createElementVNode("small", null, "(Seleccione una unidad o agregue una nueva)")
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("select", {
                id: "unidadIndicador",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((unidadIndicadorId).value = $event)),
                disabled: _ctx.loading
              }, [
                _cache[22] || (_cache[22] = _createElementVNode("option", {
                  disabled: "",
                  value: ""
                }, "Seleccione una unidad", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unidadesUnicas.value, (u) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: u.id_unidad,
                    value: u.nombre
                  }, _toDisplayString(u.nombre), 9, _hoisted_15))
                }), 128))
              ], 8, _hoisted_14), [
                [_vModelSelect, unidadIndicadorId.value]
              ]),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (mostrarNuevaUnidad.value = !mostrarNuevaUnidad.value), ["prevent"]))
              }, " Nueva Unidad ")
            ])
          ]),
          (mostrarNuevaUnidad.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { for: "nuevaUnidadNombre" }, [
                    _createTextVNode(" Ingrese la nueva unidad "),
                    _createElementVNode("small", null, "(Ej: Porcentaje, Nivel, Índice)")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nuevo-cerrar",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {mostrarNuevaUnidad.value = false; nuevaUnidadNombre.value = ''})
                  }, "×")
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "nuevaUnidadNombre",
                  type: "text",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((nuevaUnidadNombre).value = $event)),
                  disabled: _ctx.loading
                }, null, 8, _hoisted_18), [
                  [_vModelText, nuevaUnidadNombre.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { for: "nombreIndicador" }, [
              _createTextVNode(" Tipo Indicador "),
              _createElementVNode("small", null, "(Seleccione un tipo o agregue uno nuevo)")
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("select", {
                id: "nombreIndicador",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((nombreIndicadorId).value = $event)),
                disabled: _ctx.loading
              }, [
                _cache[25] || (_cache[25] = _createElementVNode("option", {
                  disabled: "",
                  value: ""
                }, "Seleccione un tipo de indicador", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nombresUnicos.value, (n) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: n.id_nombre,
                    value: n.nombre
                  }, _toDisplayString(n.nombre), 9, _hoisted_22))
                }), 128))
              ], 8, _hoisted_21), [
                [_vModelSelect, nombreIndicadorId.value]
              ]),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (mostrarNuevoNombre.value = !mostrarNuevoNombre.value), ["prevent"]))
              }, " Nuevo Tipo ")
            ])
          ]),
          (mostrarNuevoNombre.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { for: "nuevoNombreIndicador" }, [
                    _createTextVNode(" Ingrese el tipo de indicador "),
                    _createElementVNode("small", null, "(Ej: De capacidad, proceso orientado al resultado, de logro)")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nuevo-cerrar",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => {mostrarNuevoNombre.value = false; nuevoNombreIndicador.value = ''})
                  }, "×")
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "nuevoNombreIndicador",
                  type: "text",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((nuevoNombreIndicador).value = $event)),
                  disabled: _ctx.loading
                }, null, 8, _hoisted_25), [
                  [_vModelText, nuevoNombreIndicador.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_26, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { for: "formulaIndicador" }, [
              _createTextVNode(" Fórmula "),
              _createElementVNode("small", null, "(Seleccione una fórmula o agregue una nueva)")
            ], -1)),
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("select", {
                id: "formulaIndicador",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formulaIndicadorId).value = $event)),
                disabled: _ctx.loading
              }, [
                _cache[28] || (_cache[28] = _createElementVNode("option", {
                  disabled: "",
                  value: ""
                }, "Seleccione una fórmula", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formulasUnicas.value, (f) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: f.id_formula,
                    value: f.nombre
                  }, _toDisplayString(f.nombre), 9, _hoisted_29))
                }), 128))
              ], 8, _hoisted_28), [
                [_vModelSelect, formulaIndicadorId.value]
              ]),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (mostrarNuevaFormula.value = !mostrarNuevaFormula.value), ["prevent"]))
              }, " Nueva Fórmula ")
            ])
          ]),
          (mostrarNuevaFormula.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[30] || (_cache[30] = _createElementVNode("label", { for: "nuevaFormulaNombre" }, [
                    _createTextVNode(" Nombre de la nueva fórmula "),
                    _createElementVNode("small", null, "(Ej: (Logros/Metas)*100)")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "nuevo-cerrar",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => {mostrarNuevaFormula.value = false; nuevaFormulaNombre.value = ''})
                  }, "×")
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "nuevaFormulaNombre",
                  type: "text",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((nuevaFormulaNombre).value = $event)),
                  disabled: _ctx.loading
                }, null, 8, _hoisted_32), [
                  [_vModelText, nuevaFormulaNombre.value]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_33, [
            _cache[31] || (_cache[31] = _createElementVNode("label", { for: "descripcionIndicador" }, [
              _createTextVNode(" Descripción "),
              _createElementVNode("small", null, "(Opcional)")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "descripcionIndicador",
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((descripcionIndicador).value = $event)),
              disabled: _ctx.loading
            }, null, 8, _hoisted_34), [
              [_vModelText, descripcionIndicador.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              class: "btn salir",
              onClick: cancelar,
              disabled: _ctx.loading
            }, "Cancelar", 8, _hoisted_36),
            _createElementVNode("button", {
              class: "btn guardar",
              onClick: emitirAceptar,
              disabled: _ctx.loading || !puedeAceptar.value
            }, _toDisplayString(_ctx.loading ? 'Guardando…' : 'Aceptar'), 9, _hoisted_37)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})